import { render, staticRenderFns } from "./unlimint.vue?vue&type=template&id=397ee8be&"
import script from "./unlimint.vue?vue&type=script&lang=js&"
export * from "./unlimint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('397ee8be')) {
      api.createRecord('397ee8be', component.options)
    } else {
      api.reload('397ee8be', component.options)
    }
    module.hot.accept("./unlimint.vue?vue&type=template&id=397ee8be&", function () {
      api.rerender('397ee8be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/order/unlimint.vue"
export default component.exports